module.exports = __webpack_public_path__ + "img/piece-complete-5.ad47c1a3.svg";